module.exports = __webpack_public_path__ + "static/media/rocket.87160b4b.svg";